export enum WebSocketMessageContextCommand {
  ReloadDisplay = 'WebsocketMessageCommand_ReloadDisplay'
}
